import React from 'react';
import intl from "react-intl-universal";
import {TrashMenuConfirmation as TrashMenuConfirmationView} from "../../components/TrashMenuConfirmation/TrashMenuConfirmation";


export interface TrashMenuConfirmationProps {
    onCancel: () => void;
    mainAction: () => Promise<void>;
    mainActionText: string;
    headerText: string;
    className?: string;
    noHover?: boolean;
}

export const TrashMenuConfirmation = (
    {
        onCancel,
        mainAction,
        mainActionText,
        headerText,
        className,
        noHover = false,
    }: TrashMenuConfirmationProps) => {
    return (
        <TrashMenuConfirmationView
            onCancel={onCancel}
            mainAction={mainAction}
            mainActionText={mainActionText}
            headerText={headerText}
            messageText={intl.get('view-addition.empty-trash-confirm-message').d("You can't undo this action.")}
            cancelText={intl.get('common.cancel').d("Cancel")}
            className={className}
            noHover={noHover}
        />
    )
}
